import { buildQuery } from '../../../utils/query';

// assets-api: authentication/urls.py (auth/notifications/...). These used to
// point at reminders/notifications/, which the API never had.
export default {
  NOTIFICATIONS: ({ page = 1, rowsPerPage = 10, unread } = {}) =>
    `auth/notifications/${buildQuery({ page, page_size: rowsPerPage, unread: unread ? 'true' : '' })}`,
  UNREAD_COUNT: 'auth/notifications/unread-count/',
  MARK_AS_READ: (id) => `auth/notifications/${id}/read/`,
  MARK_ALL_AS_READ: 'auth/notifications/read-all/',
};
